import React, { createContext, useContext, useState, useEffect } from 'react';
import enTranslations from '../utils/languages/en.json';
import zhTranslations from '../utils/languages/zh.json';

const LanguageContext = createContext();

const translations = {
    en: enTranslations,
    zh: zhTranslations
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // Get saved language from localStorage or default to 'en'
        return localStorage.getItem('appLanguage') || 'en';
    });

    useEffect(() => {
        // Save language preference to localStorage
        localStorage.setItem('appLanguage', language);
    }, [language]);

    const t = (key) => {
        // Get translation for the current language
        return translations[language][key] || key;
    };

    const changeLanguage = (newLanguage) => {
        if (translations[newLanguage]) {
            setLanguage(newLanguage);
        }
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
